"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.025 14.75C14.025 15.1366 14.3384 15.45 14.725 15.45C15.9814 15.45 17 14.4314 17 13.175V7.74999C17 5.98268 15.5673 4.54999 13.8 4.54999H6.2C4.43269 4.54999 3 5.98268 3 7.74999L3 13.175C3 14.4314 4.01855 15.45 5.275 15.45V14.05C4.79175 14.05 4.4 13.6582 4.4 13.175L4.4 7.74999C4.4 6.75588 5.20589 5.94999 6.2 5.94999H13.8C14.7941 5.94999 15.6 6.75587 15.6 7.74999V13.175C15.6 13.6582 15.2082 14.05 14.725 14.05C14.3384 14.05 14.025 14.3634 14.025 14.75Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.44995 14.75C4.44995 15.1366 4.76335 15.45 5.14995 15.45H5.25C5.6366 15.45 5.95 15.1366 5.95 14.75C5.95 14.3634 5.6366 14.05 5.25 14.05H5.14995C4.76335 14.05 4.44995 14.3634 4.44995 14.75Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.0528 17.9C10.2407 17.8982 10.4201 17.8208 10.5504 17.6854L12.9044 15.2393C13.1725 14.9608 13.164 14.5177 12.8855 14.2496C12.6069 13.9815 12.1638 13.99 11.8957 14.2686L10.746 15.4631V10.6926C10.746 10.306 10.4326 9.99261 10.046 9.99261C9.65945 9.99261 9.34605 10.306 9.34605 10.6926V15.51L8.09503 14.259C7.82167 13.9856 7.37845 13.9856 7.10508 14.259C6.83172 14.5323 6.83171 14.9755 7.10508 15.2489L9.55107 17.695C9.68399 17.8279 9.86478 17.9018 10.0528 17.9Z",
  fill: "currentColor"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=CardMoveDown20.js.map